import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, formatApiErrorDetail } from '../auth';
import { KickLogo } from '../components/SocialIcons';
import '../components/account/discord.css';

const messages = { denied: 'Kick authorization was cancelled. Nothing was connected.', invalid_state: 'This Kick request expired or belongs to another browser. Please start again.', invalid_code: 'Kick did not return an authorization code.', authorization_failed: 'Kick authorization could not be verified. Please check your connection and try again.' };

export default function KickCallback() {
  const { loading, user, authHeader } = useAuth();
  const navigate = useNavigate(), pending = useRef(null);
  const [params] = useState(() => new URLSearchParams(window.location.hash.slice(1)));
  const [error, setError] = useState('');
  useEffect(() => {
    if (loading) return;
    let alive = true;
    window.history.replaceState(window.history.state, '', window.location.pathname);
    const ticket = params.get('ticket');
    if (!ticket) { setError(messages[params.get('error')] || 'No Kick connection request was received.'); return; }
    if (!user) { setError('Sign in to your original GVRewards account, then connect Kick again.'); return; }
    if (!pending.current) pending.current = axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/kick/oauth/complete`, { ticket }, { headers: authHeader(), withCredentials: true, timeout: 30000 });
    pending.current.then(() => { if (alive) navigate('/account/connections', { replace: true, state: { accountTab: true } }); })
      .catch((failure) => { if (alive) setError(formatApiErrorDetail(failure.response?.data?.detail || 'Kick could not be connected. Please try again.')); });
    return () => { alive = false; };
    // A single-use ticket must not be sent twice during StrictMode effect replay.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, params, navigate, user?.id]);
  return <main className="discord-callback" data-testid="kick-callback-page">
    <Link to="/" data-testid="kick-callback-home"><img src="/gv-logo-onyx.png" alt="GVRewards" data-testid="kick-callback-logo" /></Link>
    <KickLogo className="discord-callback-icon" /><h1 data-testid="kick-callback-title">{error ? 'Kick connection' : 'Connecting Kick…'}</h1>
    {error ? <p role="alert" data-testid="kick-callback-error">{error}</p> : <p role="status" data-testid="kick-callback-status">Verifying your Kick account…</p>}
    <Link className="discord-back-link" to="/account/connections" state={{ accountTab: true }} data-testid="kick-callback-back">Return to Connected Accounts</Link>
  </main>;
}